const materialColors = [
	{ name: 'Success Color', color: '#1e4620' },
	{ name: 'Success Color Accent', color: '#295e2c' },
	{ name: 'Success Color Alt', color: '#2e7d32' },
	{ name: 'Success Color Bold', color: '#4caf50' },
	{ name: 'Success Color Light', color: '#edf7ed' },

	{ name: 'Info Color', color: '#014361' },
	{ name: 'Info Color Accent', color: '#035e88' },
	{ name: 'Info Color Alt', color: '#0277bd' },
	{ name: 'Info Color Bold', color: '#03a9f4' },
	{ name: 'Info Color Light', color: '#e5f6fd' },

	{ name: 'Warning Color', color: '#663c00' },
	{ name: 'Warning Color Accent', color: '#8c5e00' },
	{ name: 'Warning Color Alt', color: '#ed6c02' },
	{ name: 'Warning Color Bold', color: '#ff9800' },
	{ name: 'Warning Color Light', color: '#fff4e5' },

	{ name: 'Error Color', color: '#5f2120' },
	{ name: 'Error Color Accent', color: '#8c2d2b' },
	{ name: 'Error Color Alt', color: '#d32f2f' },
	{ name: 'Error Color Bold', color: '#ef5350' },
	{ name: 'Error Color Light', color: '#fdeded' },
];
export default materialColors;
